import React from 'react';

export function NexusCard({ className = '', accentColor, children, ...props }) {
  return (
    <div
      className={`stat-card ${className}`.trim()}
      style={{ ...(accentColor ? { '--accent-color': accentColor } : {}), ...(props.style || {}) }}
      {...props}
    >
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, accentColor, active = false, onClick }) {
  return (
    <NexusCard
      accentColor={accentColor}
      className={`${onClick ? 'today-branch-card' : ''} ${active ? 'active' : ''}`.trim()}
      onClick={onClick}
    >
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub ? <div className="stat-sub">{sub}</div> : null}
    </NexusCard>
  );
}
